import { IMarketYoyGrowthExpectationApi } from '../api/types'
import { IMarketYoyGrowthExpectation } from '../model/types'

/**
 * `fYear` isn't on the wire — it's the resolved `Planning` entry's fiscal
 * year, passed in since `PlanningDetails` only carries a `PlanningEntryID`
 * foreign key.
 */
export const mapMarketYoyGrowthExpectationFromApi = (
  data: IMarketYoyGrowthExpectationApi,
  fYear: number
): IMarketYoyGrowthExpectation => ({
  entryId: data.EntryId,
  uid: data.UID,
  created: data.Created,
  createdBy: data.CreatedBy,
  modified: data.Modified,
  modifiedBy: data.ModifiedBy,
  planningEntryId: data.PlanningEntryID,
  fYear,
  rtm: data.RTM,
  market: data.Market,
  offering: data.Offering,
  productCategory: data.Category,
  yoyGrowth: data.FinYoYGrowth,
  sobYoyGrowth: data.SobYoYGrowth,
  isExpanded: Boolean(data.IsExpanded),
})
